const HaccpTextConstants = {
  Common: {
    Title       : "食品メーカー向けサービス",
  },
  Registration: {
    Add              : "追加",
    Insert           : "挿入",
    Remove           : "削除",
    Save             : "保存",
    CheckAll         : "すべて選択",
    UncheckAll       : "すべて解除",
    Saved            : "保存しました。",
    Ok               : "OK",
    Cancel           : "キャンセル",
    FileNotFound     : "設定ファイルがありません。",
    NotRegistered    : "測定対象が登録されていません。",
    RemoveSelectedRow: "選択行を削除します。",
  },
  Record: {
    Start                : "開始",
    End                  : "終了",
    DateRangeTitle       : "測定日：",
    WaveDash             : "～",
    Search               : "検索",
    CSV                  : "CSV",
    Print                : "印刷",
    InputDateForStartDate: "測定日の開始は日付を入力してください。",
    InputDateForEndDate  : "測定日の終了は日付を入力してください。",
    InputCorrectDateRange: "測定日の開始より終了が新しい日付になるように入力してください。",
    CSVDownloadFailed    : "CSVのダウンロードに失敗しました。",
  },
  TempMeasurementRegistration: {
    Title      : "温度測定 測定対象登録",
    IsValid    : "有効",
    Code       : "コード",
    Target     : "測定対象",
    Saved      : "保存しました。",
    InputTarget: "測定対象を入力してください。",
  },
  CookingTempMeasurementRegistration: {
    Title                   : "調理温度測定 測定対象登録",
    IsValid                 : "有効",
    Code                    : "コード",
    Target                  : "測定対象",
    Method                  : "加熱方法",
    HeatingTempLower        : "加熱温度(MIN)",
    HeatingTempUpper        : "加熱温度(MAX)",
    MeasurePoints           : "測定点数",
    HeatingDuration         : "加熱時間",
    IsCooling               : "冷却工程",
    CoolingTempLower        : "冷却温度(MIN)",
    CoolingTempUpper        : "冷却温度(MAX)",
    Saved                   : "保存しました。",
    InputANonDuplicateCode  : "コードは重複しない値を入力してください。",
    InputTarget             : "測定対象を入力してください。",
    InputMethod             : "加熱方法を入力してください。",
    InputCorrectHeatingRange: "加熱温度(MIN)より加熱温度(MAX)が高い温度になるように入力してください。",
    InputCorrectCoolingRange: "冷却温度(MIN)より冷却温度(MAX)が高い温度になるように入力してください。",
  },
  // HeatingAndCoolingTempMeasurementRegistration: {
  //   Title                     : "加熱冷却温度測定 測定対象登録",
  //   IsValid                   : "有効",
  //   Code                      : "コード",
  //   Target                    : "測定対象",
  //   Process                   : "工程",
  //   HeatingTempLower          : "加熱温度下限",
  //   HeatingTempUpper          : "加熱温度上限",
  //   CoolingTempLower          : "冷却温度下限",
  //   CoolingTempUpper          : "冷却温度上限",
  //   ReheatingTempLower        : "再加熱温度下限",
  //   ReheatingTempUpper        : "再加熱温度上限",
  //   InputTarget               : "測定対象を入力してください。",
  //   InputProcess              : "工程を入力してください。",
  //   InputCorrectHeatingRange  : "加熱温度下限より加熱温度上限が高い温度になるように入力してください。",
  //   InputCorrectCoolingRange  : "冷却温度下限より冷却温度上限が高い温度になるように入力してください。",
  //   InputCorrectReheatingRange: "再加熱温度下限より再加熱温度上限が高い温度になるように入力してください。",
  // },
  TempMeasurementRecord: {
    Title : "温度測定 記録",
    Target: "測定対象",
    Person: "担当者",
    Date  : "日時",
    Temp  : "温度"
  },
  ReceivingTempMeasurementRecord: {
    Title : "受入温度測定 記録",
    Target: "測定対象",
    Person: "担当者",
    Date  : "日時",
    Temp  : "温度"
  },
  CookingTempMeasurementRecord: {
    Title        : "調理温度測定 記録",
    Target       : "測定対象",
    Method       : "加熱方式",
    Person       : "加熱調理担当者",
    OilTemp      : "油温",
    StartDate    : "加熱調理開始時刻",
    CoreTemp1    : "中心温度1",
    Date1        : "測定日時1",
    CoreTemp2    : "中心温度2",
    Date2        : "測定日時2",
    CoreTemp3    : "中心温度3",
    Date3        : "測定日時3",
    EndDate      : "加熱調理終了時刻",
    CoolingPerson: "冷却担当者",
    CoolingDate  : "冷却温度測定日時",
    CoolingTemp  : "冷却温度",
  },
  // HeatingAndCoolingTempMeasurementRecord: {
  //   Title  : "加熱冷却温度測定 記録",
  //   Target : "測定対象",
  //   Process: "工程",
  //   Person : "担当者",
  //   Date   : "日時",
  //   Temp   : "温度"
  // },
  CabinetTempMeasurementRecord: {
    Title: "庫温度測定 記録",
    Name : "庫名",
    Date : "日時",
    Temp : "温度",
  }
};

export default HaccpTextConstants;
